import { render, staticRenderFns } from "./BuyPackageDialog.vue?vue&type=template&id=f884bdfa&scoped=true"
import script from "./BuyPackageDialog.vue?vue&type=script&lang=js"
export * from "./BuyPackageDialog.vue?vue&type=script&lang=js"
import style0 from "./BuyPackageDialog.vue?vue&type=style&index=0&id=f884bdfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f884bdfa",
  null
  
)

export default component.exports